import { sortRoomsByPrice } from '@shared/helpers';

import { normalizeRegimen } from '../helpers/regimen';

export const filterByName = (hotels, nameFilter) => {
  if (!nameFilter) {
    return hotels;
  }

  const filterLower = String(nameFilter).toLowerCase().trim();

  return hotels.filter(hotel => {
    const hotelNameFormatted = String(hotel?.name || '').toLowerCase();
    const hotelSupplierFormatted = String(hotel?.supplier || '').toLowerCase();

    return (
      hotelNameFormatted?.includes(filterLower) ||
      `sup-${hotelSupplierFormatted}`.includes(filterLower) ||
      `int-${hotel.id_integration}` === filterLower ||
      `prv-${hotel.id_provider}` === filterLower
    );
  });
};

export const filterByPrice = (
  hotels,
  pricesFiltered,
  priceRange,
  totalNights
) => {
  if (!priceRange?.[0]) {
    return hotels;
  }

  return hotels
    .map(hotel => {
      const filteredRates = hotel.rates.filter(rate => {
        const price = Math.ceil(rate?.price?.details_USD?.total / totalNights);

        return (
          (price >= pricesFiltered?.[0] && price <= pricesFiltered?.[1]) ||
          rate.rooms?.[0]?.availability === 'ORQ'
        );
      });

      return filteredRates.length > 0
        ? { ...hotel, rates: filteredRates }
        : null;
    })
    .filter(Boolean);
};

export const filterByBoard = (hotels, filter) => {
  if (filter === 'allOptions') {
    return hotels;
  }

  return hotels
    ?.map(hotel => {
      if (!Array.isArray(hotel.rates)) {
        return null;
      }

      const boardFilteredRates = hotel.rates.filter(rate => {
        const description = rate.board?.description?.split('(')?.[0]?.trim();
        if (!description) {
          return false;
        }

        const { label } = normalizeRegimen(description);
        return label === filter;
      });

      if (boardFilteredRates.length > 0) {
        return {
          ...hotel,
          rates: sortRoomsByPrice(boardFilteredRates),
        };
      }

      return null;
    })
    .filter(Boolean);
};
